import React, { useState } from "react"

import { useHistory } from "react-router-dom"
import { gql, useQuery } from "urql"

import WithLoadingIndicator from "~tailwindui/Basics/WithLoadingIndicator"
import Table from "~tailwindui/Table/Table"

import Header from "components/OrganizationAdmin/components/DisplayableFormikForm/Header"

const StudyGroupsPage = () => {
  const history = useHistory()

  const [page, setPage] = useState(1)
  const [result] = useQuery({
    query: studyGroupsQuery,
    variables: { page },
  })

  return (
    <>
      <WithLoadingIndicator
        result={result}
        header={<Header title="Study Groups" />}
      >
        {({ data }) => (
          <>
            <Table
              data={data.viewer.organization.studyGroups}
              changePage={setPage}
              rowCallback={studyGroup =>
                history.push(`/study_groups/${studyGroup.id}`)
              }
              cols={[
                { header: "Name", value: studyGroup => studyGroup.name },
                {
                  header: "Tutor",
                  value: studyGroup => studyGroup.tutor?.fullName,
                },
                {
                  header: "Subject",
                  value: studyGroup => (
                    <ul key="subjectsList" className="list-none">
                      {studyGroup.subjects.map(subject => (
                        <li key={subject.id}>{subject.name}</li>
                      ))}
                    </ul>
                  ),
                },
                {
                  header: "Students",
                  value: studyGroup => (
                    <ul key="studentsList" className="list-none">
                      {studyGroup.students.map(student => (
                        <li key={student.id}>{student.fullName}</li>
                      ))}
                    </ul>
                  ),
                },
                {
                  header: "School",
                  value: studyGroup => studyGroup.school?.name || "N/A",
                },
              ]}
            />
          </>
        )}
      </WithLoadingIndicator>
    </>
  )
}

const studyGroupsQuery = gql`
  query studyGroups($page: Int!) {
    viewer {
      organization {
        studyGroups: paginatedStudyGroups(page: $page) {
          currentPage
          totalPages
          data {
            id
            name
            tutor {
              id
              fullName
            }
            subjects {
              id
              name
            }
            students {
              id
              fullName
            }
            school {
              id
              name
            }
          }
        }
      }
    }
  }
`

export default StudyGroupsPage
